import Vue from 'vue'
import { getSiteLink } from '@/lib/helpers/site-builder'

export const state = () => ({
  templates: [],
  sites: [],
})

export const mutations = {
  setTemplates(state, templates) {
    state.templates = templates
  },

  setSites(state, sites) {
    state.sites = sites
  },

  upsertSite(state, site) {
    const siteIndex = state.sites.findIndex(st => st.id === site.id)

    // No-op, how did we end up here?
    if (siteIndex < 0) {
      state.sites.push(site)
      return
    }

    Vue.set(state.sites, siteIndex, site)
  },

  addSite(state, site) {
    state.sites.push(site)
  },

  deleteSite(state, site) {
    state.sites = state.sites.filter(st => st.id !== site.id)
  },
}

export const getters = {
  /** Return a single site, or null */
  findSiteById: state => id => state.sites.find(site => site.id === id) || null,

  /** Return a single site that is connected to this package, or null */
  findSiteByConnectedPackage: state => pkgId =>
    state.sites.find(site => site.connected_logo_package === pkgId) || null,
}

export const actions = {
  async fetchSiteTemplates({ commit }) {
    const { data } = await this.$api.get('/api/v2/sites/templates')

    commit('setTemplates', data)

    return data
  },

  async fetchSites({ commit, dispatch }) {
    const { data } = await this.$api.get(`/api/v2/sites`)

    // if paid site exists, complete 'website' progress steps
    const paidSite = data.data.find(site => !!site.package)
    if (!!paidSite)
      dispatch('dashboard/markStepAsComplete', 'website', { root: true })

    commit('setSites', data.data)

    return data.data
  },

  async fetchSite({ commit }, id) {
    const { data } = await this.$api.get(`/api/v2/sites/${id}`)

    commit('upsertSite', data)

    return data
  },

  async createSite({ commit }, payload) {
    const { data } = await this.$api.post('/api/v2/sites', {
      template: payload.template || undefined,
      connected_logo_package: payload.connected_logo_package || undefined,
    })

    commit('addSite', data)
  },

  /**
   * Performs an update operation on the site
   */
  async updateSite({ commit }, payload) {
    const { data } = await this.$api.patch(`/api/v2/sites/${payload.site.id}`, {
      template: payload.template || undefined,
      published: payload.published || undefined,
    })

    commit('upsertSite', data)
  },

  /**
   * Performs an delete operation on the site
   */
  async deleteSite({ commit }, payload) {
    await this.$api.delete(`/api/v2/sites/${payload.site.id}`)

    commit('deleteSite', payload.site.id)
  },

  /**
   * Helper function for handling SSO redirections
   */
  async performSso(_context, id) {
    const url = await getSiteLink(this.$api, id)

    window.location.href = url
  },
}
